let MetastockTemplate = function (t, e, a) {
        let n = {
            compiled: !1, target: !1, init: function (t, e, a) {
                if (this.target = document.getElementById(t), !this.target) throw new Error(`Could not find the html element (${t}) for ${a}`);
                if (!e) throw new Error("Could not find the template for " + a);
                this.compiled = e
            }, render: function (t) {
                return void 0 === t && (t = {}), this.target.innerHTML = this.compiled(t), !0
            }
        };
        return n.init(t, e, a), n
    }, Metastock_Templates = {
        decide_quantity_line: function (t, e) {
            return 0 == t ? this.no_quantity() : this.decide_available_quantity_line(t, e)
        }, decide_available_quantity_line: function (t, e) {
        }, no_quantity: function () {
            return {icon: Metastock_Templates.icon_unavailable(), text: "Out of Stock"}
        }, exact_quantity: function (t, e) {
            let a = {icon: Metastock_Templates.icon_available(), text: `${t} available`};
            return t < e && (a.icon = Metastock_Templates.icon_unavailable()), a
        }, ranges_quantity: function (t, e) {
            let a = Metastock_Templates.icon_available(), n = "In Stock";
            return t <= e && (a = Metastock_Templates.icon_low(), n = "Limited Stock"), {icon: a, text: n}
        }, location: function (t) {
            let e = "";
            t.travel_time && (e = ` (<span>${t.travel_time}</span>)`);
            let a = "";
            t.distance && (a = `<br><span>${t.distance}</span>${e}`);
            let n = `\n        <div class="flyout-selection-container">\n            <h3 id="location-name">${t.name}</h3>\n        </div>`;
            if ((t.address || t.city) && (n += '\n            <div class="flyout-location-information">\n                <p class="flyout-location">', t.address && (n += `<span>${t.address}</span><br>`), t.city && (n += `<span>${t.city}</span>`, t.state && (n += ", ")), t.state && (n += `<span>${t.state}</span> `), t.zip && (n += `<span>${t.zip}</span> `), n += `${a}</p></div>`), t.selected ? n += '\n            <button id="flyout-store-select"\n                class="metastock-store-select-button-disabled button button--disabled"\n                disabled\n            >\n                My Store\n            </button>' : n += `\n            <button id="flyout-store-select"\n                class="metastock-store-select-button button"\n                onclick="MetastockFlyout.selectLocation(${t.id})"\n            >\n                Shop this store\n            </button>`, t.has_inventory) {
                let e = Metastock_Templates.decide_quantity_line(t.available);
                n += `\n            <div class="metastock-flyout-location-availability-container">\n                ${e.icon}\n                <p class="metastock-flyout-location-availability">\n                    ${e.text}\n                </p>\n            </div>\n        `
            }
            return n
        }, location_list: function (t) {
            let e = '<ul id="js-menu-list">';
            return t.locations.forEach((t => {
                e += `\n            <li>\n                ${Metastock_Templates.location(t)}\n            </li>`
            })), e += "</ul>", e
        }, store_availability: function (t) {
            return void 0 !== t.locations ? Metastock_Templates.all_store_availability(t) : void 0 !== t.location ? Metastock_Templates.single_store_availability(t) : void 0
        }, single_store_availability: function (t) {
            let e = '<div class="metastock-pdp-information">';
            return e += `${Metastock_Templates.store_availability_line(t)}`, e += '\n        <button id="drawer-btn"\n            onclick="MetastockFlyout.open()" type="button"\n            class="metastock-pdp-information-button metastock-pdp-small-text"\n        >\n            Check other stores\n        </button>', e += "</div>", e
        }, all_store_availability: function (t) {
            let e = '<div class="metastock-pdp-information"><ul class="metastock-pdp-location-inventory">';
            //fgc-tuan custom-logic
            t.locations[1].available += t.locations[0].available
            //end
            return t.locations.forEach((a => {

                a.quantity = t.quantity, e += `<li>${Metastock_Templates.store_availability_line(a)}</li>`
            })), e += "</ul></div>", e
        }, store_availability_line: function (t) {
            let e = !1;
            t.name || void 0 !== t.name ? e = t.name : (t.location || void 0 !== t.location) && (e = t.location);
            t.name = t.name.replace("Mordialloc","In");
            let a = t.available, n = t.quantity, o = "";
            if (a) {
                let t = Metastock_Templates.decide_quantity_line(a, n);
                o += `\n            ${t.icon}\n            <p id="availability-info" class="metastock-pdp-information-title">\n                ${t.text}`
            } else {
                let t = Metastock_Templates.no_quantity();
                t.text = "Available";
                o += t.icon, o += `<p id="unavailable-title">${t.text}`
            }
            return e && (o += ` ${e}`), o += "</p>", o.replace("In Stock","Available ");
        }, icon_available: function () {
            return '<svg id="in-stock" aria-hidden="true" focusable="false" role="presentation" class="metastock-icon metastock-icon-in-stock" viewBox="0 0 12 10">\n            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.293 9.707l-3-3a.999.999 0 1 1 1.414-1.414l2.236 2.236 6.298-7.18a.999.999 0 1 1 1.518 1.3l-7 8a1 1 0 0 1-.72.35 1.017 1.017 0 0 1-.746-.292z" fill="#00730B"></path>\n        </svg>'
        }, icon_low: function () {
            return '<svg id="in-stock" aria-hidden="true" focusable="false" role="presentation" class="metastock-icon metastock-icon-in-stock" viewBox="0 0 12 10">\n            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.293 9.707l-3-3a.999.999 0 1 1 1.414-1.414l2.236 2.236 6.298-7.18a.999.999 0 1 1 1.518 1.3l-7 8a1 1 0 0 1-.72.35 1.017 1.017 0 0 1-.746-.292z" fill="#EFB219"></path>\n        </svg>'
        }, icon_unavailable: function () {
            return '<svg id="out-of-stock-variant" aria-hidden="true" focusable="false" role="presentation" class="metastock-icon metastock-icon-out-of-stock" viewBox="0 0 12 13">\n            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.414 6.5l4.293-4.293A.999.999 0 1 0 10.293.793L6 5.086 1.707.793A.999.999 0 1 0 .293 2.207L4.586 6.5.293 10.793a.999.999 0 1 0 1.414 1.414L6 7.914l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L7.414 6.5z" fill="#DD2200"></path>\n        </svg>'
        }
    }, metastock_template_location_list = Metastock_Templates.location_list,
    metastock_template_store_availability = Metastock_Templates.store_availability, MetastockStorage = function () {
        let t = {address: "", locations_distances: !1, location_id: !1}, e = {
            _key: "metastock_user", init: function () {
                let e = {};
                try {
                    e = JSON.parse(localStorage.getItem(this._key))
                } catch (t) {
                }
                e || this.store(t)
            }, getData: function (t) {
                return this.retrieve()[t]
            }, hasData: function (t) {
                try {
                    let e = JSON.parse(localStorage.getItem(this._key));
                    if (void 0 === e || void 0 === e[t] || !1 === e[t]) return !1;
                    if (e[t].length) return e[t].length;
                    for (let a in e[t]) if ("object" == typeof e[t] && e[t].hasOwnProperty(a) && (void 0 !== e[t][a].id || e[t][a].id)) return !0;
                    return !1
                } catch (t) {
                    console.error("error in MetastockStorage.hasData", t)
                }
                return !1
            }, hasLocationId: function () {
                try {
                    let t = JSON.parse(localStorage.getItem(this._key));
                    if (void 0 === t || void 0 === t.location_id || !1 === t.location_id) return !1;
                    if (Number(t.location_id)) return !0
                } catch (t) {
                    console.error("error in MetastockStorage.hasLocationId", t)
                }
                return !1
            }, setData: function (t, e) {
                let a = this.retrieve();
                return a[t] = e, this.store(a)
            }, retrieve: function () {
                let e = {};
                try {
                    e = JSON.parse(localStorage.getItem(this._key)), e || (e = {})
                } catch (t) {
                }
                for (let a in t) t.hasOwnProperty(a) && void 0 === e[a] && (e[a] = t[a]);
                return e
            }, store: function (t) {
                try {
                    localStorage.setItem(this._key, JSON.stringify(t))
                } catch (t) {
                    return console.error(t), !1
                }
                return !0
            }
        };
        return e.init(), e
    }(), MetastockApiFunctions = {
        pagination: 24, extractApiResponse: function (t) {
            let e = [];
            return t.destinationAddresses.forEach(((a, n) => {
                e.push({
                    address: a,
                    distance: t.rows[0].elements[n].distance.value,
                    distance_text: t.rows[0].elements[n].distance.text,
                    duration: t.rows[0].elements[n].duration.text
                })
            })), e
        }, combineResults: function (t) {
            let e = [];
            return t.forEach((t => {
                t.forEach((t => {
                    e.push(t)
                }))
            })), e.sort(((t, e) => t.distance < e.distance ? -1 : e.distance < t.distance ? 1 : 0)), e
        }, getLocationsFromResponse(t) {
            let e = [];
            return t.forEach((t => {
                let a = t.address, n = t.distance_text, o = Number(t.distance), i = t.duration,
                    s = MetastockLocations.findByAddress(a).location;
                void 0 !== s && (s.distance = n, s.travel_time = i, e.push({
                    id: s.id,
                    meters: o,
                    miles: n,
                    distance: n,
                    travel_time: i
                }))
            })), e
        }, getPagedLocations: function () {
            let t = [];
            if (MetastockLocations.each((e => {
                t.push(MetastockLocations.oneLineAddress(e))
            })), t.length <= this.pagination) return [t];
            let e = 0, a = 0, n = [];
            return t.forEach((t => {
                n[a] ? n[a].push(t) : n.push([t]), ++e === this.pagination && (a++, e = 0)
            })), n
        }
    }, MetastockGoogleApi = function (t) {
        return {
            name: "MetastockGoogleApi", api_key: t, init: function () {
                if (this.api_key.length) {
                    var e = document.createElement("script");
                    e.src = "https://maps.googleapis.com/maps/api/js?callback=init_metastock_distance_api&key=" + t, e.async = !0, document.head.appendChild(e)
                }
            }, fetch: function (t, e) {
                let a = MetastockApiFunctions.getPagedLocations(), n = new google.maps.DistanceMatrixService, o = [], i = 0,
                    s = function (t, e) {
                        if ("OK" != e) throw new Error("Network response was not OK: " + e);
                        o.push(MetastockApiFunctions.extractApiResponse(t)), i++
                    };
                a.forEach((e => {
                    n.getDistanceMatrix({
                        origins: [t],
                        destinations: e,
                        travelMode: "DRIVING",
                        unitSystem: google.maps.UnitSystem.IMPERIAL,
                        avoidHighways: !1,
                        avoidTolls: !0
                    }, s)
                }));
                let c = setInterval((() => {
                    if (i >= a.length) {
                        let t = MetastockApiFunctions.combineResults(o),
                            a = MetastockApiFunctions.getLocationsFromResponse(t);
                        MetastockStorage.setData("locations_distances", a), MetastockFlyout.renderLocationList(), clearInterval(c), void 0 !== e && e(t)
                    }
                }), 200)
            }
        }
    }, MetastockLocations = {
        setSelectedToFirstInList: !1, checkForLocations: function () {
            if ("undefined" == typeof metastock_locations) throw new Error("Could not find Metastock locations. Did you include them?");
            let t = MetastockStorage.getData("location_id");
            for (let e = 0; e < metastock_locations.length; e++) {
                let a = metastock_locations[e], n = !1;
                (!t && 0 === e || t == a.id) && (n = !0), metastock_locations[e].distance = !1, metastock_locations[e].meters = !1, metastock_locations[e].travel_time = !1, metastock_locations[e].selected = n
            }
        }, createHash: function (t) {
            return t.replace(/avenue/gi, "ave").replace(/apartment/gi, "apt").replace(/boulevard/gi, "blvd").replace(/center/gi, "ctr").replace(/circle/gi, "cir").replace(/court/gi, "ct").replace(/drive/gi, "dr").replace(/expressway/gi, "expy").replace(/heights/gi, "hts").replace(/highway/gi, "hwy").replace(/island/gi, "is").replace(/junction/gi, "jct").replace(/lake/gi, "lk").replace(/lane/gi, "ln").replace(/mountain/gi, "mtn").replace(/parkway/gi, "pkwy").replace(/place/gi, "pl").replace(/plaza/gi, "plz").replace(/ridge/gi, "rdg").replace(/road/gi, "rd").replace(/room/gi, "rm").replace(/square/gi, "sq").replace(/station/gi, "sta").replace(/street/gi, "st").replace(/suite/gi, "ste").replace(/terrace/gi, "ter").replace(/trail/gi, "trl").replace(/turnpike/gi, "tpke").replace(/valley/gi, "vly").replace(/northeast/gi, "ne").replace(/northwest/gi, "nw").replace(/southeast/gi, "se").replace(/southwest/gi, "sw").replace(/east/gi, "e").replace(/north/gi, "n").replace(/south/gi, "s").replace(/west/gi, "w").replace(/ |\.|,|\#|-/g, "").toLowerCase()
        }, getSortedLocations: function () {
            let t = MetastockStorage.getData("locations_distances");
            if (!t || !t.length) return this.getWithSelectedFirst();
            this.checkForLocations();
            let e = [], a = this.findById(MetastockStorage.getData("location_id"));
            t.sort(((t, e) => void 0 === t.meters ? 1 : void 0 === e.meters || t.meters < e.meters ? -1 : 0));
            for (let n = 0; n < t.length; n++) {
                let o = t[n];
                if (a && this.setSelectedToFirstInList && o.id == a.id) continue;
                let i = o.id;
                metastock_locations.forEach((t => {
                    i == t.id && (t.distance = o.distance, t.meters = o.meters, t.travel_time = o.travel_time, e.push(t))
                }))
            }
            return e
        }, getSelected: function () {
            this.checkForLocations();
            let t = MetastockStorage.getData("location_id");
            if (!t) {
                let t = this.first();
                return MetastockStorage.setData("location_id", t.id), t
            }
            return this.findById(t)
        }, getWithSelectedFirst: function () {
            this.checkForLocations();
            let t = MetastockStorage.getData("location_id");
            if (!t) return metastock_locations;
            let e = [], a = this.findById(t);
            return a && (a.selected = !0, e.push(a)), this.each((t => {
                a && t.id == a.id || (t.selected = !1, e.push(t))
            })), e
        }, each: function (t) {
            this.checkForLocations();
            for (let e = 0; metastock_locations.length > e; e++) t(metastock_locations[e], e)
        }, findByAddress: function (t) {
            return this.checkForLocations(), t = t.replace(", USA", ""), t = MetastockLocations.createHash(t), this.find((e => {
                let a = MetastockLocations.createHash(this.oneLineAddress(e, ""));
                return -1 !== t.indexOf(a)
            }))
        }, findById: function (t) {
            this.checkForLocations();
            let e = this.find((function (e) {
                return t == e.id
            }));
            return !1 !== e && e.location
        }, findByLocation: function (t) {
            this.checkForLocations();
            let e = this.findById(t.id);
            return !!e && e.location
        }, find: function (t) {
            this.checkForLocations();
            for (let e = 0; metastock_locations.length > e; e++) {
                let a = metastock_locations[e];
                if (t(a, e)) return {index: e, location: a}
            }
            return !1
        }, first: function () {
            return this.checkForLocations(), this.find((() => !0)).location
        }, oneLineAddress: function (t, e) {
            void 0 === e && (e = " ");
            let a = t.address + e;
            return t.address2 && (a += t.address2 + e), a += t.city + e + t.province_code + e + t.zip, a
        }, standardize: function (t) {
            for (let e = 0; e < t.length; e++) t[e] = this.standardizeLocation(t[e]);
            return t
        }, standardizeLocation: function (t) {
            return void 0 === t.address && (t.address = t.address1), void 0 === t.state && (t.state = t.province_code), t
        }
    }, metastockInventoryWarningTitle = function (t) {
        if (void 0 !== t.title && t.title.length) return t.title;
        let e = "", a = !1;
        return void 0 !== t.product_title && t.product_title.length && (a = !0, e = t.product_title), void 0 !== t.variant_title && "Default Title" !== t.variant_title && (a ? e += ` - ${t.variant_title}` : e = t.variant_title), e
    }, MetastockExactInventoryStrategy = function () {
        return {
            name: "exact", quantityIsAcceptable: function (t, e) {
                return !isNaN(t) && t >= e
            }, warningMessage: function (t) {
                let e = metastockInventoryWarningTitle(t), a = "";
                void 0 !== e && e && (a += `for the product, "${e}",`);
                let n = t.requested_quantity, o = 0;
                return void 0 !== t.on_hand && (o = t.on_hand), `\n                The requested quantity of ${n} \n                ${a}\n                exceeds the availability of ${o}\n            `
            }
        }
    }, MetastockRangesInventoryStrategy = function () {
        return {
            name: "ranges", quantityIsAcceptable: function (t, e) {
                return !isNaN(t) && (t > 0 || 0 == e)
            }, warningMessage: function (t) {
                return `Cannot fulfill out-of-stock product, "${metastockInventoryWarningTitle(t)}"`
            }
        }
    }, MetastockInventoryStrategy = function (t) {
        return {
            strategy: t, checkCart: function (t) {
                let e = {length: 0, items: [], map: {}}, a = MetastockLocations.getSelected(),
                    n = t.getLocationInventoryData(a.id);
                for (const t in n) for (const a in n[t]) {
                    let o = n[t][a];
                    e = this.checkItem(e, o)
                }
                return e
            }, checkItem: function (t, e) {
                let a = Number(e.requested_quantity), n = Number(e.on_hand);
                if (this.quantityIsAcceptable(n, a)) return t;
                let o = this.strategy.warningMessage(e);
                t.length++, t.items.push(o);
                let i = e.variant_id;
                return t.map[i] = o, t
            }, quantityIsAcceptable: function (t, e) {
                return this.strategy.quantityIsAcceptable(t, e)
            }
        }
    }, MetastockInventory = {
        allow_add_when_quantity_exceeded: !1,
        disable_add_when_quantity_exceeded: !0,
        quantity: 0,
        inventory_levels: !1,
        current_variant_id: !1,
        html_add_to_cart_button: !1,
        html_buy_now_button: !1,
        html_quantity_input: !1,
        pdp_location_display_type: "selected_location",
        template_store_availability: !1,
        cached_url: !1,
        init: function (t, e, a, n) {
            if (void 0 === t || !document.getElementById("js-store-availability")) return !1;
            if (this.current_variant_id = t, void 0 !== n && (this.pdp_location_display_type = n), "undefined" == typeof metastock_inventory) throw new Error("Could not find inventory. Did you include the metastock_inventory variable?");
            this.inventory_levels = metastock_inventory;
            let o = this;
            this.template_store_availability = new MetastockTemplate("js-store-availability", metastock_template_store_availability, "Store availability message"), this.disable_add_when_quantity_exceeded = e, this.allow_add_when_quantity_exceeded = !e, this.checkForAddToCartButton(a), o.html_quantity_input = document.querySelector("input[name=quantity]"), o.html_quantity_input && (o.quantity = parseInt(o.html_quantity_input.value), o.html_quantity_input.addEventListener("change", (function (t) {
                o.quantity = parseInt(t.target.value), o.ensureInventoryLevel(), o.renderStoreAvailability()
            }))), o.ensureInventoryLevel(), o.renderStoreAvailability(), o.cached_url = window.location.search, setInterval(o.checkVariantQueryString, 500), document.addEventListener("MetastockLocationUpdated", (() => {
                o.ensureInventoryLevel(), o.renderStoreAvailability()
            }))
        },
        checkForAddToCartButton: function (t) {
            t && "" !== t || (t = "#addToCart-product-template"), this.html_add_to_cart_button = document.querySelector(t), this.html_add_to_cart_button || (this.html_add_to_cart_button = document.querySelector("button[name=add]"));
            let e = document.getElementsByClassName("shopify-payment-button__button--unbranded")[0];
            void 0 !== e && (this.html_buy_now_button = e)
        },
        disableAddToCart: function () {
            this.html_add_to_cart_button && (this.html_add_to_cart_button.classList.add("product-detail-btn-disabled"), this.html_add_to_cart_button.classList.add("metastock-button-disabled"), this.html_add_to_cart_button.disabled = !0), this.html_buy_now_button && (this.html_buy_now_button.classList.add("buy-now-btns-disabled"), this.html_buy_now_button.classList.add("metastock-button-disabled"), this.html_buy_now_button.disabled = !0)
        },
        enableAddToCart: function () {
            this.html_add_to_cart_button && (this.html_add_to_cart_button.classList.remove("product-detail-btn-disabled"), this.html_add_to_cart_button.classList.remove("metastock-button-disabled"), this.html_add_to_cart_button.disabled = !1), this.html_buy_now_button && (this.html_buy_now_button.classList.remove("buy-now-btns-disabled"), this.html_buy_now_button.classList.remove("metastock-button-disabled"), this.html_buy_now_button.disabled = !1)
        },
        ensureInventoryLevel: function () {
            let t = MetastockStorage.getData("location_id"), e = this.getInventoryForLocation(t);
            return this.html_quantity_input && !metastock_inventory_strategy.quantityIsAcceptable(parseInt(e), this.quantity) ? (this.disableAddToCart(), !1) : (this.enableAddToCart(), !0)
        },
        hasInventoryLevels: function () {
            return this.inventory_levels
        },
        getInventoryForLocation: function (t) {
            if (!this.current_variant_id || void 0 === this.inventory_levels[this.current_variant_id]) return !1;
            let e = this.inventory_levels[this.current_variant_id];
            for (let a = 0; a < e.length; a++) {
                let n = e[a];
                if (t == n.location_id) return parseInt(n.available)
            }
            return !1
        },
        renderStoreAvailability: function () {
            "all_locations" === this.pdp_location_display_type ? this.renderAllStoreAvailability() : this.renderSelectedStoreAvailability()
        },
        renderAllStoreAvailability: function () {
            let t = {locations: MetastockFlyout.getLocationInventoryData(), quantity: this.quantity};
            return this.template_store_availability.render(t)
        },
        renderSelectedStoreAvailability: function () {
            let t = MetastockStorage.getData("location_id"), e = MetastockLocations.findById(t),
                a = {available: this.getInventoryForLocation(t), location: e.name, quantity: this.quantity};
            return this.template_store_availability.render(a)
        },
        checkVariantQueryString: function () {
            window.location.search !== MetastockInventory.cached_url && (MetastockInventory.setVariantIdFromQueryString(), MetastockInventory.ensureInventoryLevel(), MetastockInventory.renderStoreAvailability(), MetastockInventory.cached_url = window.location.search, document.dispatchEvent(new CustomEvent("MetastockVariantChanged", {detail: MetastockInventory.current_variant_id})))
        },
        setVariantIdFromQueryString: function () {
            let t = new URLSearchParams(window.location.search).get("variant");
            t && (MetastockInventory.current_variant_id = t)
        }
    }, MetastockFlyout = {
        is_open: !1, html_flyout: !1, html_location_list: !1, template_location_list: !1, init: function () {
            let t = this;
            t.html_flyout = document.getElementById("js-metastock-flyout"), t.template_location_list = new MetastockTemplate("js-metastock-location-list", metastock_template_location_list, "Location flyout menu"), t.renderLocationList(), document.addEventListener("MetastockVariantChanged", (() => {
                MetastockFlyout.renderLocationList()
            })), document.addEventListener("MetastockLocationUpdated", (() => {
                MetastockFlyout.renderLocationList()
            }))
        }, close: function () {
            this.is_open = !1, this.html_flyout.classList.remove("enabled-shift")
        }, open: function () {
            this.is_open = !0, this.html_flyout.classList.add("enabled-shift")
        }, toggle: function () {
            this.is_open ? this.close() : this.open()
        }, getLocationInventoryData: function () {
            let t = MetastockLocations.getSortedLocations(), e = MetastockInventory.hasInventoryLevels();
            for (let a = 0; a < t.length; a++) {
                let n = t[a];
                t[a].has_inventory = e, e && (t[a].available = MetastockInventory.getInventoryForLocation(n.id))
            }
            return t
        }, renderLocationList: function () {
            let t = {locations: this.getLocationInventoryData()};
            return this.template_location_list.render(t)
        }, selectLocation: function (t) {
            MetastockStorage.setData("location_id", t), document.dispatchEvent(new CustomEvent("MetastockLocationUpdated", {detail: t})), this.renderLocationList()
        }
    }, MetastockLocationDisplay = {
        html_names: !1, init: function () {
            this.html_names = document.querySelectorAll(".js-metastock-store-name"), this.setLocationName(), self = this, document.addEventListener("MetastockLocationUpdated", (() => {
                self.setLocationName()
            })), document.querySelectorAll(".metastock-selected-location-container").forEach((function (t) {
                t.style.display = ""
            }))
        }, setLocationName: function () {
            if (!this.html_names) return;
            let t = MetastockLocations.getSelected();
            this.html_names.forEach((e => {
                e.innerHTML = t.name
            }))
        }
    }, MetastockGeolocation = {
        html_form: !1, html_address_input: !1, html_clear_address_button: !1, api: !1, init: function (t) {
            if (this.html_form = document.getElementById("metastock-form-address"), !this.html_form) return console.debug("Could not find Metastock geolocation form. Was it included?"), !1;
            if (void 0 === t) {
                if ("undefined" === window.MetastockNmrApi) return console.debug("Could not find a suitable Api to use"), !1;
                t = new MetastockNmrApi
            }
            this.api = t, void 0 !== this.api.init && this.api.init(), document.getElementById("metastock-geo-form-container").style.display = "", this.html_clear_address_button = document.getElementById("js-metastock-clear-address");
            let e = MetastockStorage.getData("address");
            this.html_address_input = document.getElementById("metastock-address-input"), e && this.html_address_input && (this.html_address_input.value = e), this.html_form.addEventListener("submit", this.searchAddress), this.html_clear_address_button.addEventListener("click", this.clearAddress)
        }, clearAddress: function (t) {
            t.preventDefault(), document.getElementById("metastock-address-input").value = "", MetastockStorage.setData("address", !1), MetastockStorage.setData("locations_distances", !1), document.dispatchEvent(new CustomEvent("MetastockLocationUpdated"))
        }, searchAddress: function (t) {
            t.preventDefault();
            let e = document.getElementById("metastock-address-input").value, a = MetastockStorage.getData("address");
            if (a && NaN === Number(a) && a.lowerCase == e.lowerCase || Number(a) === Number(e)) return !0;
            MetastockStorage.setData("address", e);
            let n = MetastockGeolocation.api.fetch(e);
            if (void 0 === n || void 0 === n.then) return !1 !== n && void MetastockGeolocation.updateLocations(n);
            n.then((t => {
                if (!1 === t) return !1;
                MetastockGeolocation.updateLocations(t)
            })).catch((t => {
                console.error("There has been a problem with your fetch operation:", t), alert("There was an issue retrieving distance information. Please try again soon")
            }))
        }, updateLocations: function (t) {
            MetastockStorage.setData("locations_distances", t), document.dispatchEvent(new CustomEvent("MetastockLocationUpdated"))
        }
    }, MetastockCartData = function () {
        let t = {
            locations: {}, products: {}, variant_map: {}, addProductTitle: function (t, e) {
                if (e.product_title.length) return void (this.products[t] = e.product_title);
                let a;
                void 0 !== e.variant_title && e.variant_title.length && (a = e.title.replace(` - ${e.variant_title}`, ""), this.products[t] = a), void 0 !== e.title && e.title.length && (this.products[t] = e.title)
            }, ensureProductData: function () {
                for (let t in this.locations) for (let e in this.locations[t]) {
                    let a = this.products[e];
                    for (let n in this.locations[t][e]) {
                        let o = this.locations[t][e][n];
                        void 0 === o.product_title && (o.product_title = a, o.product_id = e, this.locations[t][e][n] = o)
                    }
                }
            }
        };
        return {
            init: function (e) {
                MetastockLocations.getSortedLocations().forEach((e => {
                    t.locations[e.id] = {}
                }));
                let a = MetastockLocations.getSelected();
                e.forEach((e => {
                    void 0 !== e.product_title && e.product_title.length && (t.products[e.product_id] = e.product_title), e.inventory.forEach(((n, o) => {
                        0 === o && (n.location_id = a.id), t.locations[n.location_id][e.product_id] = {}, t.locations[n.location_id][e.product_id][n.variant_id] = {}, this.add(n, !1)
                    }))
                })), t.ensureProductData()
            }, add: function (e, a) {
                if (void 0 === a && (a = !0), void 0 === e.location_id || !e.location_id || void 0 === e.variant_id || !e.variant_id || void 0 === e.product_id || !e.product_id) return;
                let n = e.product_id, o = e.variant_id, i = e.location_id;
                t.products[n] || t.addProductTitle(n, e), t.variant_map[o] = n, void 0 === t.locations[i] && (t.locations[i] = {}), void 0 === t.locations[i][n] && (t.locations[i][n] = {}), o && (t.locations[i][n][o] = e), a && (t.ensureProductData(), e.requested_quantity && this.updateRequestedQuantity(o, e.requested_quantity))
            }, get: function () {
                return t
            }, getLocationInventoryData: function (e) {
                return "undefined" === t.locations[e] ? {} : t.locations[e]
            }, getVariantInventoryData: function (e, a, n) {
                return void 0 !== t.locations[e][a][n] ? t.locations[e][a][n] : {
                    product_id: a,
                    variant_id: n,
                    location_id: e,
                    on_hand: 0
                }
            }, replace: function (e) {
                let a = e.location_id, n = e.product_id, o = e.variant_id;
                t.locations[a][n][o] = e
            }, updateRequestedQuantity: function (e, a) {
                for (const n in t.locations) {
                    let o = t.variant_map[e], i = this.getVariantInventoryData(n, o, e);
                    i.requested_quantity = a, t.locations[n][o][e] = i
                }
            }
        }
    }(), MetastockCart = {
        cart_data: {},
        inputs_data: [],
        allow_disable_checkout: !1,
        inventory_strategy: null,
        html_checkout_buttons: !1,
        locations: !1,
        init: function (t, e, a) {
            this.cart_data = t, this.inventory_strategy = e, void 0 !== a && a && (this.allow_disable_checkout = !0, this.html_checkout_buttons = document.querySelectorAll(a), null === this.html_checkout_buttons && console.info("The provided css selector, " + a + ", could not be found on the page. Are you sure it's correct?")), this.ensureValidCart(), document.querySelectorAll("input[name='updates[]']").length && document.querySelectorAll(".quantity__button").length && (this.setVariantIdDataForInputs(), this.setUpQuantityUpdateInterval());
            let n = this;
            document.addEventListener("MetastockLocationUpdated", (() => {
                n.ensureValidCart()
            }))
        },
        ensureValidCart: function () {
            if (!this.cart_data) return !1;
            this.clearWarnings();
            let t = this.inventory_strategy.checkCart(this.cart_data);
            if (!t.length) return this.enableCheckout(), !1;
            this.disableCheckout(), this.showGlobalCartWarning(t), this.showCartItemWarnings(t)
        },
        clearWarnings: function () {
            let t = document.getElementById("js-cart-warning");
            t.innerHTML = "", t.classList.remove("metastock-cart-quantity-warning");
            let e = document.querySelectorAll(".metastock-cart-item-warning");
            e && e.length && e.forEach((t => {
                t.innerHTML = ""
            }))
        },
        showGlobalCartWarning: function (t) {
            let e = MetastockLocations.getSelected(), a = document.getElementById("js-cart-warning");
            t.length && (a.innerHTML = `\n                    <div class="metastock-cart-warning-wrap">\n                        <p class="metastock-cart-warning-message">\n                            Please adjust quantities in your cart\n                            at the store: ${e.name}\n                        </p>\n                        <ul class="metastock-cart-warning-list">\n                            <li>${t.items.join("</li><li>")}</li>\n                        </ul>\n                    </div>\n                `), a && a.innerHTML.length && a.classList.add("metastock-cart-quantity-warning")
        },
        showCartItemWarnings: function (t) {
            let e = document.querySelectorAll(".metastock-cart-item-warning");
            if (!e || !e.length) return;
            let a = MetastockLocations.getSelected();
            for (const e in t.map) if (t.map.hasOwnProperty(e)) {
                let n = t.map[e], o = document.getElementById(`js-cart-warning-${e}`);
                this.addWarningElementToCartItemRow(o, a, n)
            }
        },
        setVariantIdDataForInputs: function () {
            let t = this;
            document.querySelectorAll(".quantity__button").forEach((function (e) {
                let a;
                a = "minus" === e.name ? e.nextElementSibling : e.previousElementSibling;
                let n = a.dataset.index, o = "#CartItem-" + n,
                    i = new URL(document.querySelector(o + " .cart-item__name").href);
                t.inputs_data[i.searchParams.get("variant")] = n
            }))
        },
        setUpQuantityUpdateInterval: function () {
            let t = this;
            return setInterval((function () {
                let e = !1, a = document.querySelectorAll("input[name='updates[]']"), n = MetastockLocations.getSelected(),
                    o = MetastockCartData.getLocationInventoryData(n.id);
                for (let n in o) for (let i in o[n]) {
                    let s = o[n][i], c = t.inputs_data[i], r = !1;
                    a.forEach((t => {
                        let a = t.dataset.index;
                        if (c != a) return;
                        let n = parseInt(t.value);
                        s.variant_id == i && (r = !0, parseInt(s.requested_quantity) !== n && (e = !0, s.requested_quantity = n, MetastockCartData.replace(s)))
                    })), r || (e = !0, MetastockCartData.updateRequestedQuantity(i, 0))
                }
                e && t.ensureValidCart()
            }), 2e3)
        },
        addWarningElementToCartItemRow: function (t, e, a) {
            let n = e.name, o = document.createElement("p");
            o.innerHTML = `Please adjust the cart. ${a} at the store: ${n}`, t.append(o), o.classList.add("metastock-item-quantity-warning")
        },
        disableCheckout: function () {
            this.allow_disable_checkout && this.html_checkout_buttons && this.html_checkout_buttons.length && this.html_checkout_buttons.forEach((t => {
                t.classList.add("metastock-button-disabled"), t.disabled = !0
            }))
        },
        enableCheckout: function () {
            this.allow_disable_checkout && this.html_checkout_buttons && this.html_checkout_buttons.length && this.html_checkout_buttons.forEach((t => {
                t.classList.remove("metastock-button-disabled"), t.disabled = !1
            }))
        }
    }, Metastock = {
        version: "1.02", init: function (t) {
            window.metastock_locations = window.metastock_locations || [], MetastockStorage.hasLocationId() || MetastockStorage.setData("location_id", MetastockLocations.first().id), window.metastock_cart_data = window.metastock_cart_data || !1, window.metastock_inventory = window.metastock_inventory || !1, window.metastock_variant_id = window.metastock_variant_id || !1, window.metastock_cart_data = window.metastock_cart_data || !1, !metastock_variant_id && document.getElementById("productSelect-product-template") && (metastock_variant_id = document.querySelector("#productSelect-product-template option[selected=selected]").value);
            let e = !0;
            void 0 !== t.disable_add_when_quantity_exceeded && (e = t.disable_add_when_quantity_exceeded);
            let a = null;
            void 0 !== t.add_to_cart_selector && (a = t.add_to_cart_selector);
            let n = "selected_location";
            void 0 !== t.pdp_location_display_type && (n = t.pdp_location_display_type);
            let o = "exact", i = 5;
            void 0 !== t.track_quantities && (o = t.track_quantities, "ranges" === o && ((void 0 === t.range_allows_add || t.range_allows_add) && (e = !1, a = null), void 0 !== t.low_stock_max && (i = t.low_stock_max), Metastock_Templates.decide_available_quantity_line = function (t, e) {
                return Metastock_Templates.ranges_quantity(t, i)
            })), "exact" === o && (Metastock_Templates.decide_available_quantity_line = function (t, e) {
                return Metastock_Templates.exact_quantity(t, e)
            }), window.metastock_inventory_strategy = MetastockInventoryStrategy("ranges" === o ? MetastockRangesInventoryStrategy() : MetastockExactInventoryStrategy()), MetastockInventory.init(metastock_variant_id, e, a, n), MetastockLocationDisplay.init(), MetastockFlyout.init(), void 0 !== t.api && MetastockGeolocation.init(t.api);
            let s = document.getElementById("js-cart-warning");
            if (s) {
                let t = !1;
                s.dataset.checkoutSelector && (t = s.dataset.checkoutSelector), MetastockCartData.init(metastock_cart_data), MetastockCart.init(MetastockCartData, metastock_inventory_strategy, t)
            }
        }
    };